import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpCode } from 'types';
import { HttpError } from 'utils/http-error';
import { ModelJson } from '../types';
import { getModel } from './api';
import { copyWithout } from '../../../utils/copy-without';
import { encode } from 'js-base64';

type InitialState = { isError: boolean; data: ModelJson | null; errorCode: HttpCode | null };

const initialState: InitialState = { isError: false, data: null, errorCode: null };

const fetchModelThunk = createAsyncThunk('pageModel/FETCH_MODEL', getModel);

const { actions, reducer } = createSlice({
  name: 'pageModel',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchModelThunk.pending, state => {
        state.data = null;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchModelThunk.fulfilled, (state, { payload }) => {
        const excludeProps = ['mobileApp', 'footer', 'regions', 'experiments'];

        // удалить ненужный поля из model.json
        // TODO: поправить типы
        const newPayload: ModelJson = excludeProps.reduce((accumulator, currentValue) => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          return copyWithout(accumulator, currentValue) as ModelJson;
        }, payload as ModelJson);

        // TODO: хардкод для возможности получать на клиенте исходный html полученный из CMS
        if (newPayload['raw-html']) {
          newPayload['raw-html'] = encode(newPayload['raw-html']);
        }

        state.data = newPayload;
        state.isError = false;
        state.errorCode = null;
      })
      .addCase(fetchModelThunk.rejected, (state, { payload }) => {
        throw new HttpError(payload as HttpCode);
      });
  },
});

export { actions, reducer, fetchModelThunk };
